import { createCommand, LexicalCommand } from "lexical";

export const INSERT_LINK_COMMAND: LexicalCommand<void> = createCommand(
  "INSERT_LINK_COMMAND"
);

export const REMOVE_LINK_COMMAND: LexicalCommand<void> = createCommand(
  "REMOVE_LINK_COMMAND"
);
